import React from "react";
import { useContext } from "react";
import { TenantContext } from "../../contexts/TenantContext";
import ErrorDisplay from "../common/error/ErrorDisplay";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";

interface IDXRouteProps {
  children: React.ReactNode;
}

export const IDXRoute: React.FC<IDXRouteProps> = ({ children }) => {
  const { config } = useContext(TenantContext);
  const navigate = useNavigate();

  console.log("Tenant Config in IDXRoute:", config);
  console.log("Flag value:", config?.flag);

  const isLocalhost =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1" ||
    window.location.hostname.endsWith(".localhost");

  if (!isLocalhost && config?.flag) {
    return (
      <ErrorDisplay
        message="Hey! Our Property Search Needs a Temporary Break"
        details="Don't worry! We're just doing some quick updates to make your search experience even better. In the meantime, why not try our home valuation tool? It's a great way to discover your property's value! 😊"
        image="/assets/images/TECHNICAL.webp"
        buttonText="Try Our Home Valuation Tool"
        buttonIcon={<ArrowRight className="w-5 h-5" />}
        onButtonClick={() => navigate("/valuation")}
      />
    );
  }

  return <>{children}</>;
};

export default IDXRoute;
